"use client";
import React, { useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { useRouter, useSearchParams, usePathname } from "next/navigation";

// 内联搜索图标 SVG 替代 phosphor-icons
const SearchIcon = ({ onClick, className }: { onClick: () => void; className?: string }) => (
	<svg 
		onClick={onClick}
		className={className}
		fill="none" 
		stroke="currentColor" 
		viewBox="0 0 24 24"
		width="20"
		height="20"
	>
		<path 
			strokeLinecap="round" 
			strokeLinejoin="round" 
			strokeWidth={2} 
			d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" 
		/>
	</svg>
);

const BlogSearch = () => {
	const t = useTranslations();
	const router = useRouter();
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const [searchTitle, setSearchTitle] = useState("");

	// 从URL参数中获取当前搜索值
	useEffect(() => {
		const currentSearch = searchParams.get("search") || "";
		setSearchTitle(currentSearch);
	}, [searchParams]);

	// 处理搜索提交
	const handleSearch = () => {
		const params = new URLSearchParams();
		if (searchTitle.trim()) {
			params.set("search", searchTitle.trim());
		}
		// 搜索时重置到第一页
		params.set("page", "1");

		const newUrl = `${pathname}?${params.toString()}`;
		router.push(newUrl);
	};

	// 处理回车键搜索
	const handleKeyPress = (e: React.KeyboardEvent) => {
		if (e.key === "Enter") {
			handleSearch();
		}
	};

	return (
		<div className="form-search relative h-12 w-full">
			<input
				className="border-line h-full w-full rounded-lg border px-4 py-2"
				type="text"
				value={searchTitle}
				placeholder={t("base.Search")}
				onChange={(e) => setSearchTitle(e.target.value)}
				onKeyPress={handleKeyPress}
			/>
			<SearchIcon
				onClick={handleSearch}
				className="text-secondary absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer duration-300 hover:text-black"
			/>
		</div>
	);
};

export default React.memo(BlogSearch);
